import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import BorderClearIcon from '@mui/icons-material/BorderClear';
import BloquearAccesoModal from "../macajes/bloquearaccesomodal";
import apiService from "../../../actions/services";
import TourGuia from '../../../../componentes/TourGuia'; // Ajusta la ruta según tu estructura


const EstructuraAPI = () => {
  const { user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [comentarios, setComentarios] = useState({});
  const [paginaActual, setPaginaActual] = useState(1);
  const [registrosSeleccionados, setRegistrosSeleccionados] = useState([]);
  const [listaEmpleados, setEmpleadosLista] = useState([]);
  
  // Función para obtener fechas iniciales (primer día del mes y fecha actual)
  const getFechasIniciales = () => {
    const hoy = new Date();
    const cincoDiasAtras = new Date(hoy);
    cincoDiasAtras.setDate(hoy.getDate() - 5);
    
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    return {
      fechaInicio: formatDate(cincoDiasAtras),
      fechaFin: formatDate(hoy)
    };
  };

  const { fechaInicio, fechaFin } = getFechasIniciales();
  const [fechaSeleccionada, setFechaSeleccionada] = useState(fechaInicio);
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState(fechaFin);

  const registrosPorPagina = 100;
  const [filtros, setFiltros] = useState({
    area: '',
    turno:'',
    compania: '',
    numeroAlternativo: '',
    nombre: '',
    puesto: '',
    unidad: ''
  });

  // Cargar empleados y lanzar búsqueda al iniciar
  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        // Cargar empleados
        const structura = { CodigoEjecutor: user.id_usuario };
        const response = await apiService.get("ObtenerEmpleadosActivos_Jerarquia", structura, user);
        const data =  response;
        console.log(data)
        const datosGenerados = JSON.parse(data.datos_Generados);
        console.log('Datos Generados (JSON):', datosGenerados);
        setEmpleadosLista(datosGenerados);
        
        // Lanzar búsqueda de marcajes automáticamente
        await enviarDatos();
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
        setError("Error al cargar datos iniciales");
      }
    };

    cargarDatosIniciales();
  }, [user.id_usuario]);

  const handleFiltroChange = (e) => {
    setFiltros({
      ...filtros,
      [e.target.name]: e.target.value,
    });
  };

  const registrosFiltrados = respuesta
    ? respuesta.filter((registro) => {
        const area = String(registro.arf_nombre || '').toLowerCase();
        const compania = String(registro.cia_descripcion || '').toLowerCase();
        const numeroAlternativo = String(registro.exp_codigo_alternativo || '');
        const nombre = String(registro.exp_apellidos_nombres || '').toLowerCase();
        const puesto = String(registro.pue_nombre || '').toLowerCase();
        const unidad = String(registro.uni_descripcion || '').toLowerCase();
        return (
          (!filtros.area || area.includes(filtros.area.toLowerCase())) &&
          (!filtros.compania || compania.includes(filtros.compania.toLowerCase())) &&
          (!filtros.numeroAlternativo || numeroAlternativo.includes(filtros.numeroAlternativo)) &&
          (!filtros.nombre || nombre.includes(filtros.nombre.toLowerCase())) &&
          (!filtros.puesto || puesto.includes(filtros.puesto.toLowerCase())) &&
          (!filtros.turno || unidad.includes(filtros.turno.toLowerCase())) &&
          (!filtros.unidad || unidad.includes(filtros.unidad.toLowerCase()))
        );
      })
    : [];

  const indexUltimoRegistro = paginaActual * registrosPorPagina;
  const indexPrimerRegistro = indexUltimoRegistro - registrosPorPagina;
  const registrosPaginaActual = registrosFiltrados.slice(indexPrimerRegistro, indexUltimoRegistro);

  // Función para obtener el índice original en el array respuesta
  const obtenerIndiceOriginal = (registroFiltrado) => {
    return respuesta.findIndex(registro => 
      registro.exp_codigo_alternativo === registroFiltrado.exp_codigo_alternativo &&
      registro.Fecha === registroFiltrado.Fecha
    );
  };

  const toggleSeleccionarTodos = () => {
    const indicesOriginales = registrosPaginaActual.map(registro => 
      obtenerIndiceOriginal(registro)
    ).filter(index => index !== -1);
    
    if (indicesOriginales.every(index => registrosSeleccionados.includes(index))) {
      setRegistrosSeleccionados(prev => 
        prev.filter(index => !indicesOriginales.includes(index))
      );
    } else {
      setRegistrosSeleccionados(prev => {
        const nuevos = indicesOriginales.filter(index => !prev.includes(index));
        return [...prev, ...nuevos];
      });
    }
  };

  const todosSeleccionados = registrosPaginaActual.length > 0 && 
    registrosPaginaActual.every(registro => 
      registrosSeleccionados.includes(obtenerIndiceOriginal(registro))
    );

  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setRespuesta(null);
    setComentarios({});
    setPaginaActual(1);
    setRegistrosSeleccionados([]);
    
    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ListaMarcasEmpleadosBiometricoJerarquia',
        Datos_Recibidos: JSON.stringify({ 
          FechaIni: fechaFormateada, 
          FechaFin: fechaFormateada2, 
          CodUsuario: user.usuario  
        }),
      },
    };
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    try {
      const response = await fetch(fetchDataUrl);
      const data = await response.json();
      console.log('Respuesta de la API:', data);

      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);
        console.log('Datos Generados (JSON):', datosGenerados);

        if (typeof datosGenerados.MARCAS === 'string') {
          datosGenerados.MARCAS = JSON.parse(datosGenerados.MARCAS);
        }

        setRespuesta(datosGenerados.MARCAS);
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  const handleComentarioChange = (index, value) => {
    setComentarios((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  const handleRevision = async (marca, indexGlobal) => {
    console.log("Linea Completa", user);

    const MarcajeRevisado = {
      MarcajeUsu: marca.exp_codigo_alternativo,
      MarcajeFecha: marca.Fecha, 
      SupervisorUsu: user.id_usuario
    };
    
    console.log("JSON ENVIADO", MarcajeRevisado);
    const resp = await apiService.post("MarcajeRevisado", MarcajeRevisado);
    console.log(resp);
    
    if (respuesta) {
      const nuevosDatos = [...respuesta];
      const indiceReal = indexGlobal;
      
      if (nuevosDatos[indiceReal]) {
        nuevosDatos[indiceReal] = {
          ...nuevosDatos[indiceReal],
          EstadoRevisado: `Revisado por ${user.nombre}`
        };
        
        setRespuesta(nuevosDatos);
      }
    }
  };

  const handleSeleccionRegistro = (registro) => {
    const indiceOriginal = obtenerIndiceOriginal(registro);
    
    if (indiceOriginal === -1) return;
    
    setRegistrosSeleccionados((prev) => {
      if (prev.includes(indiceOriginal)) {
        return prev.filter((i) => i !== indiceOriginal);
      } else {
        return [...prev, indiceOriginal];
      }
    });
  };

  const getColor = (Estado) => {
    if (Estado === 'No Revisado') {
      return 'rgba(222, 224, 40, 0.8)';
    } else {
      return 'rgba(27, 227, 46, 0.7)';
    }
  };

  const formatearFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    const dia = String(fecha.getUTCDate()).padStart(2, '0');
    const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
    const año = fecha.getUTCFullYear();
    return `${dia}/${mes}/${año}`;
  };

  const enviarRegistrosSeleccionados = async () => {
    if (registrosSeleccionados.length === 0) {
      setError('Por favor, selecciona al menos un registro.');
      return;
    }
    
    const datosEnviar = registrosSeleccionados.map((index) => {
      const marcaje = respuesta[index];
      return {
        CodEmp: marcaje.exp_codigo_alternativo,
        Fecha: formatearFecha(marcaje.Fecha),
        Comentario: comentarios[index] || '',
        CodEmpAut: user.id_usuario,
      };
    });
    
    console.log("JSON ENVIADO :", datosEnviar);
    const body = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'GenerarComentarioMarcas',
        Datos_Recibidos: JSON.stringify(datosEnviar),
        Datos_Generados: ""
      },
    };
    
    try {
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      console.log('Respuesta del servidor:', data);
      if (data.datos_Generados) {
        alert('Registros enviados correctamente.');
        setRegistrosSeleccionados([]);
        await enviarDatos();
      } else {
        setError('Error al enviar los registros.');
      }
    } catch (error) {
      console.error('Error al enviar los registros:', error);
      setError('Error al enviar los registros.');
    }
  };

  const exportarAExcel = () => {
    if (!registrosFiltrados || registrosFiltrados.length === 0) {
      setError('No hay datos para exportar.');
      return;
    }
    const ws = XLSX.utils.json_to_sheet(registrosFiltrados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Marcajes');
    XLSX.writeFile(wb, 'marcajes.xlsx');
  };

  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina);
  };

  return (
    <div className="container-fluid mt-4">
      {/* Botón para reiniciar el tour */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="text-center mb-0">Validación de Marcajes</h1>
 
      </div>
      


      {/* Filtros y controles superiores */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label">Fecha Inicial:</label>
              <input
                type="date"
                className="form-control"
                name="fechaInicio"
                value={fechaSeleccionada}
                onChange={(e) => setFechaSeleccionada(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">Fecha Final:</label>
              <input
                type="date"
                className="form-control"
                name="fechaFin"
                value={fechaSeleccionada2}
                onChange={(e) => setFechaSeleccionada2(e.target.value)}
              />
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={enviarDatos}
                disabled={loading}
              >
                {loading ? 'Cargando...' : 'Buscar Marcajes'}
              </button>
            </div>
            <div className="col-md-3 d-flex align-items-end justify-content-end">
              {user.rol.some(rol => rol.Id_Perfil === 150005 || rol.Id_Perfil === 130001 || rol.Id_Perfil === 1) && (
                <button
                  className="btn btn-success me-2"
                  onClick={exportarAExcel}
                >
                  <BorderClearIcon fontSize="small" className="me-1" />
                  Exportar Excel
                </button>
              )}
              <BloquearAccesoModal empleados={listaEmpleados} />
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-2 mb-2">
              <input 
                type="text" 
                name="unidad" 
                className="form-control" 
                placeholder="Unidad" 
                value={filtros.unidad} 
                onChange={handleFiltroChange} 
              />
            </div>
            <div className="col-md-2 mb-2">
              <input 
                type="text" 
                name="turno" 
                className="form-control" 
                placeholder="Turno" 
                value={filtros.turno} 
                onChange={handleFiltroChange} 
              />
            </div>
            <div className="col-md-2 mb-2">
              <input 
                type="text" 
                name="puesto" 
                className="form-control" 
                placeholder="Puesto" 
                value={filtros.puesto} 
                onChange={handleFiltroChange} 
              />
            </div>
            <div className="col-md-2 mb-2">
              <input 
                type="text" 
                name="numeroAlternativo" 
                className="form-control" 
                placeholder="Código Colaborador" 
                value={filtros.numeroAlternativo} 
                onChange={handleFiltroChange} 
              />
            </div>
            <div className="col-md-4 mb-2">
              <input 
                type="text" 
                name="nombre" 
                className="form-control" 
                placeholder="Nombre" 
                value={filtros.nombre} 
                onChange={handleFiltroChange} 
              />
            </div>
          </div>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      
      {/* Contenedor de tabla con scroll horizontal */}
      {respuesta && (
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Resultados de Marcajes</h5>
            <button
              className="btn btn-success"
              onClick={enviarRegistrosSeleccionados}
              disabled={registrosSeleccionados.length === 0}
            >
              Enviar Seleccionados ({registrosSeleccionados.length})
            </button>
          </div>
          
          <div className="card-body p-0">
            <div style={{ overflowX: 'auto', width: '100%' }}>
              <table className="table table-bordered table-striped mb-0" style={{ minWidth: '1500px' }}>
                <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr>
                    <th style={{ width: '50px' }}>
                      <button 
                        className={`btn btn-sm ${todosSeleccionados ? 'btn-light' : 'btn-outline-light'}`}
                        onClick={toggleSeleccionarTodos}
                        title="Seleccionar/Deseleccionar todos"
                      >
                        {todosSeleccionados ? '✓' : '○'}
                      </button>
                    </th>
                    <th style={{ width: '80px' }}>Código</th>
                    <th style={{ width: '250px' }}>Nombres</th>
                    <th style={{ width: '250px' }}>Unidad</th>
                    <th style={{ width: '200px' }}>Puesto</th>
                    <th style={{ width: '100px' }}>Fecha</th>
                    <th style={{ width: '300px' }}>Horario</th>
                    <th style={{ width: '80px' }}>Acción</th>
                    <th style={{ width: '150px' }}>Estado Supervisión</th>
                    <th style={{ width: '150px' }}>Estado Planilla</th>
                    <th style={{ width: '300px' }}>Comentarios</th>
                    <th style={{ width: '300px' }}>Acciones Anteriores</th>
                  </tr>
                </thead>
                <tbody>
                  {registrosPaginaActual.map((marcaje, index) => {
                    const indiceOriginal = obtenerIndiceOriginal(marcaje);
                    const estaSeleccionado = registrosSeleccionados.includes(indiceOriginal);
                    
                    return (
                      <tr style={{ backgroundColor: getColor(marcaje.EstadoRevisado) }} key={indiceOriginal}>
                        <td>
                          {marcaje.EstadoRevisado === "No Revisado" && (
                            <input
                              type="checkbox"
                              checked={estaSeleccionado}
                              onChange={() => handleSeleccionRegistro(marcaje)}
                            />
                          )}
                        </td>
                        <td>{marcaje.exp_codigo_alternativo}</td>
                        <td className="text-truncate" title={marcaje.exp_apellidos_nombres}>
                          {marcaje.exp_apellidos_nombres}
                        </td>
                        <td className="text-truncate" title={marcaje.uni_descripcion}>
                          {marcaje.uni_descripcion}
                        </td>
                        <td className="text-truncate" title={marcaje.pue_nombre}>
                          {marcaje.pue_nombre}
                        </td>
                        <td className="text-truncate">{marcaje.Fecha}</td>
                        <td className="text-truncate" style={{ maxWidth: '300px' }}>
                          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {Array.from({ length: 14 }, (_, i) => {
                              const eKey = `HoraE${i + 1}`;
                              const sKey = `HoraS${i + 1}`;
                              const tieneDatos = marcaje[eKey] || marcaje[sKey];
                              return tieneDatos ? (
                                <div key={i} className="small">
                                  {`H${i+1}: ${marcaje[eKey] || "-"} - ${marcaje[sKey] || "-"}`}
                                </div>
                              ) : null;
                            })}
                          </div>
                        </td>
                        <td>
                          {marcaje.EstadoRevisado === "No Revisado" && (
                            <button
                              className={`btn btn-sm ${
                                marcaje.revisado === "No Revisado" ? "btn-outline-success" : "btn-success"
                              }`}
                              onClick={() => handleRevision(marcaje, indiceOriginal)}
                              title="Marcar como revisado"
                            >
                              ✔
                            </button>
                          )}
                        </td>
                        <td>{marcaje.EstadoRevisado}</td>
                        <td>{marcaje.Estado}</td>
                        <td>
                          {marcaje.EstadoRevisado === "No Revisado" && (
                            <textarea
                              className="form-control"
                              value={comentarios[indiceOriginal] || ''}
                              onChange={(e) => handleComentarioChange(indiceOriginal, e.target.value)}
                              rows="2"
                              placeholder="Ingrese comentario..."
                            />
                          )}
                        </td>
                        <td className="text-truncate" title={marcaje.AccionesGeneradas}>
                          {marcaje.AccionesGeneradas}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            
            {/* Paginación */}
            <div className="d-flex justify-content-center mt-3 p-3 bg-light">
              <nav>
                <ul className="pagination">
                  {[...Array(Math.ceil(registrosFiltrados.length / registrosPorPagina)).keys()].map((numero) => (
                    <li
                      key={numero + 1}
                      className={`page-item ${paginaActual === numero + 1 ? 'active' : ''}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => cambiarPagina(numero + 1)}
                      >
                        {numero + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EstructuraAPI;